{
  "titles": {
    "menu": "Dashboard"
  }
}
